<template>
  <InputHeader :label="label" :description="description" />
  <textarea
    v-model="computedValue"
    :name="name"
    :placeholder="placeholder"
    :disabled="disabled"
    class="mt-2 border border-gray-500 rounded text-black resize-y"
    :class="small ? 'p-1' : 'p-2'"
    rows="3"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import InputHeader from './InputHeader.vue'

type Props = {
  modelValue: string
  label?: string
  description?: string
  placeholder?: string
  name?: string
  small?: boolean
  disabled?: boolean
}
const props = defineProps<Props>()
const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const computedValue = computed({
  get: () => props.modelValue,
  set: (value: string) => emit('update:modelValue', value ?? ''),
})
</script>

<style lang="scss"></style>
